import { colors } from 'bold-ui'

import { ProntuarioCard } from '../ProntuarioCard'
import { PuerperioCard } from './PuerperioCard'

interface PuerperioSectionProps {
  prontuarioId: ID
  cidadaoId: ID
  atendimentoId: ID
  dataReferencia: Instant
}

export function PuerperioSection(props: Readonly<PuerperioSectionProps>) {
  const { prontuarioId, cidadaoId, atendimentoId, dataReferencia } = props

  return (
    <ProntuarioCard title='Puerpério' titleBackgroundColor={colors.blue.c90}>
      <PuerperioCard
        prontuarioId={prontuarioId}
        cidadaoId={cidadaoId}
        atendimentoId={atendimentoId}
        dataReferencia={dataReferencia}
      />
    </ProntuarioCard>
  )
}
